import { render, staticRenderFns } from "./Advanced.vue?vue&type=template&id=26111bcc&"
import script from "./Advanced.vue?vue&type=script&lang=js&"
export * from "./Advanced.vue?vue&type=script&lang=js&"
import style0 from "./Advanced.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26111bcc')) {
      api.createRecord('26111bcc', component.options)
    } else {
      api.reload('26111bcc', component.options)
    }
    module.hot.accept("./Advanced.vue?vue&type=template&id=26111bcc&", function () {
      api.rerender('26111bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/cards/Advanced.vue"
export default component.exports